export const DOMAIN_OVERVIEW = [
  {
    titleKey: 'domains.cyber.title',
    path: '/cybersecurity',
    summaryKey: 'domains.cyber.summary',
    tags: [
      'domains.cyber.tags.threat',
      'domains.cyber.tags.oidc',
      'domains.cyber.tags.jwt',
      'domains.cyber.tags.siem',
      'domains.cyber.tags.pipeline',
    ],
  },
  {
    titleKey: 'domains.ai.title',
    path: '/ai-engineering',
    summaryKey: 'domains.ai.summary',
    tags: [
      'domains.ai.tags.rag',
      'domains.ai.tags.embeddings',
      'domains.ai.tags.vector',
      'domains.ai.tags.llmops',
      'domains.ai.tags.observability',
    ],
  },
  {
    titleKey: 'domains.fullStack.title',
    path: '/full-stack',
    summaryKey: 'domains.fullStack.summary',
    tags: [
      'domains.fullStack.tags.api',
      'domains.fullStack.tags.postgres',
      'domains.fullStack.tags.docker',
      'domains.fullStack.tags.caching',
      'domains.fullStack.tags.deployment',
    ],
  },
];

export const CYBERSECURITY_SECTIONS = {
  capabilities: [
    'cyberPage.capabilities.0',
    'cyberPage.capabilities.1',
    'cyberPage.capabilities.2',
    'cyberPage.capabilities.3',
    'cyberPage.capabilities.4',
  ],
  architecture: [
    {
      labelKey: 'cyberPage.architecture.identity.label',
      valueKey: 'cyberPage.architecture.identity.value',
    },
    {
      labelKey: 'cyberPage.architecture.api.label',
      valueKey: 'cyberPage.architecture.api.value',
    },
    {
      labelKey: 'cyberPage.architecture.data.label',
      valueKey: 'cyberPage.architecture.data.value',
    },
    {
      labelKey: 'cyberPage.architecture.runtime.label',
      valueKey: 'cyberPage.architecture.runtime.value',
    },
  ],
  caseStudies: [
    {
      titleKey: 'cyberPage.cases.0.title',
      problemKey: 'cyberPage.cases.0.problem',
      approachKey: 'cyberPage.cases.0.approach',
      outcomeKey: 'cyberPage.cases.0.outcome',
    },
    {
      titleKey: 'cyberPage.cases.1.title',
      problemKey: 'cyberPage.cases.1.problem',
      approachKey: 'cyberPage.cases.1.approach',
      outcomeKey: 'cyberPage.cases.1.outcome',
    },
  ],
};

export const AI_ENGINEERING_SECTIONS = {
  architectureBlocks: [
    { nameKey: 'aiPage.blocks.ingestion.name', detailKey: 'aiPage.blocks.ingestion.detail' },
    { nameKey: 'aiPage.blocks.embedding.name', detailKey: 'aiPage.blocks.embedding.detail' },
    { nameKey: 'aiPage.blocks.retrieval.name', detailKey: 'aiPage.blocks.retrieval.detail' },
    { nameKey: 'aiPage.blocks.orchestration.name', detailKey: 'aiPage.blocks.orchestration.detail' },
    { nameKey: 'aiPage.blocks.generation.name', detailKey: 'aiPage.blocks.generation.detail' },
    { nameKey: 'aiPage.blocks.evaluation.name', detailKey: 'aiPage.blocks.evaluation.detail' },
  ],
  performance: [
    'aiPage.performance.0',
    'aiPage.performance.1',
    'aiPage.performance.2',
    'aiPage.performance.3',
  ],
  labs: [
    {
      titleKey: 'aiPage.labs.0.title',
      systemKey: 'aiPage.labs.0.system',
      challengeKey: 'aiPage.labs.0.challenge',
      resultKey: 'aiPage.labs.0.result',
    },
    {
      titleKey: 'aiPage.labs.1.title',
      systemKey: 'aiPage.labs.1.system',
      challengeKey: 'aiPage.labs.1.challenge',
      resultKey: 'aiPage.labs.1.result',
    },
  ],
};

export const FULLSTACK_ENGINEERING_SECTIONS = {
  pillars: [
    {
      titleKey: 'fullStackPage.pillars.backend.title',
      detailsKey: 'fullStackPage.pillars.backend.details',
    },
    {
      titleKey: 'fullStackPage.pillars.api.title',
      detailsKey: 'fullStackPage.pillars.api.details',
    },
    {
      titleKey: 'fullStackPage.pillars.data.title',
      detailsKey: 'fullStackPage.pillars.data.details',
    },
    {
      titleKey: 'fullStackPage.pillars.devops.title',
      detailsKey: 'fullStackPage.pillars.devops.details',
    },
    {
      titleKey: 'fullStackPage.pillars.scaling.title',
      detailsKey: 'fullStackPage.pillars.scaling.details',
    },
  ],
  productionExamples: [
    {
      titleKey: 'fullStackPage.production.0.title',
      decisionKey: 'fullStackPage.production.0.decision',
      impactKey: 'fullStackPage.production.0.impact',
    },
    {
      titleKey: 'fullStackPage.production.1.title',
      decisionKey: 'fullStackPage.production.1.decision',
      impactKey: 'fullStackPage.production.1.impact',
    },
  ],
};
